import { Component } from '@angular/core';
import { CreateInventoryService } from '@inventory/pages/create-inventory/services/create-inventory.service';
import { IonNav, ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { SubCategory } from '@usf/inventory-types';
import { PopulateInventoryBaseComponent } from '../populate-inventory-base.component';

@Component({
  selector: 'app-populate-inventory-desktop-tablet',
  templateUrl: './populate-inventory-desktop-tablet.component.html',
  styleUrls: ['../populate-inventory-common-styles.scss'],
})
export class PopulateInventoryDesktopTabletComponent extends PopulateInventoryBaseComponent {
  constructor(
    nav: IonNav,
    modalController: ModalController,
    platformService: PlatformService,
    createInventoryService: CreateInventoryService,
  ) {
    super(nav, modalController, platformService, createInventoryService);
  }

  onSelectCreateInventoryOption(selectedCreateInventoryOption: SubCategory) {
    if (
      this.selectedCreateInventoryOption.code !==
      selectedCreateInventoryOption.code
    ) {
      this.deselectInventoryOrShoppingList(selectedCreateInventoryOption.code);
      this.resetInventoriesOrShoppingLists();
    }

    this.nextButtonEnabled = this.setNextButtonEnabled(
      selectedCreateInventoryOption.code,
    );
    this.dataToReturn = { selectedCreateInventoryOption };
    this.selectedCreateInventoryOption = selectedCreateInventoryOption;
  }

  deselectInventoryOrShoppingList(selectedCreateInventoryOptionCode: string) {
    if (this.dataToReturn) {
      if (
        selectedCreateInventoryOptionCode !==
          this.CreateInventoryModal.pastInventory &&
        this.dataToReturn.selectedInventory
      ) {
        this.deselectInventory();
      } else if (
        selectedCreateInventoryOptionCode !==
          this.CreateInventoryModal.shoppingList &&
        this.dataToReturn.selectedShoppingList
      ) {
        this.deselectShoppingList();
      }
    }
  }

  resetInventoriesOrShoppingLists() {
    if (
      this.selectedCreateInventoryOption.code ===
      this.CreateInventoryModal.pastInventory
    ) {
      this.inventories = this.createInventoryService.getInventories$();
    } else if (
      this.selectedCreateInventoryOption.code ===
      this.CreateInventoryModal.shoppingList
    ) {
      this.shoppingLists = this.createInventoryService.getShoppingLists$();
    }
  }
}
